import React from "react";
import "./TpcTradeFloorRooms.css";

import tradeFloorRoomImage from "../../images/tradeFloor4.webp";
import chartBg from "../../images/Chart 4.webp";

const floorSignals = [
  {
    value: "02",
    label: "World-class floors",
    trend: "gold",
  },
  {
    value: "Live",
    label: "Market sessions",
    trend: "green",
  },
  {
    value: "Guided",
    label: "Execution",
    trend: "red",
  },
];

const marketCandles = [
  "green",
  "green",
  "red",
  "green",
  "red",
  "green",
  "green",
  "red",
  "green",
  "green",
];

function TpcTradeFloorRooms({
  ctaHref = "https://andus.co.za/trade-register",
  ctaLabel = "Apply Now",
}) {
  return (
    <section
      id="tpc-trade-floor-rooms"
      className="trpc-floorRooms"
      aria-labelledby="trpc-floorRooms-title"
    >
      <div className="trpc-floorRooms__shell">
        <article className="trpc-floorRooms__stage">
          <div className="trpc-floorRooms__copy">
            <span className="trpc-floorRooms__kicker">Live trade floor</span>

            <h2 id="trpc-floorRooms-title" className="trpc-floorRooms__title">
              Take your seat.
            </h2>

            <p className="trpc-floorRooms__lead">
              Two world-class floors. Live sessions. Guided execution.
            </p>
          </div>

          <div className="trpc-floorRooms__media">
            <img
              className="trpc-floorRooms__image"
              src={tradeFloorRoomImage}
              alt="Students seated at computers inside a TPC trade floor room"
              loading="lazy"
              decoding="async"
            />

            <img
              className="trpc-floorRooms__chart"
              src={chartBg}
              alt=""
              loading="lazy"
              decoding="async"
              aria-hidden="true"
            />

            <div className="trpc-floorRooms__shade" aria-hidden="true" />
            <div className="trpc-floorRooms__grid" aria-hidden="true" />
            <span className="trpc-floorRooms__priceLine" aria-hidden="true" />

            <div className="trpc-floorRooms__candles" aria-hidden="true">
              {marketCandles.map((trend, index) => (
                <span
                  key={`${trend}-${index}`}
                  className="trpc-floorRooms__candle"
                  data-trend={trend}
                />
              ))}
            </div>
          </div>

          <div className="trpc-floorRooms__cta">
            <a className="trpc-floorRooms__btn" href={ctaHref} target="_blank" rel="noopener noreferrer">
              <span>{ctaLabel}</span>
              <span aria-hidden="true">↗</span>
            </a>
          </div>

          <div
            className="trpc-floorRooms__signalDeck"
            aria-label="Trade floor highlights"
          >
            {floorSignals.map((signal) => (
              <article
                key={`${signal.value}-${signal.label}`}
                className="trpc-floorRooms__signal"
                data-trend={signal.trend}
              >
                <strong>{signal.value}</strong>
                <span>{signal.label}</span>
              </article>
            ))}
          </div>
        </article>
      </div>
    </section>
  );
}

export default TpcTradeFloorRooms;